<template>
  <div class="batchVague">
    <el-select
      v-model="computedValue"
      placeholder="请选择"
      size="mini"
      @change="selectChange"
    >
      <el-option
        v-for="item in computedOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'BatchVagueSelect',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    showRemote: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: [
        {
          label: '模糊',
          value: 0
        },
        {
          label: '批量',
          value: 1
        },
        {
          label: '远程搜索',
          value: 2
        }
      ]
    }
  },

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    computedOptions() {
      return this.showRemote
        ? this.options
        : this.options.filter((opt) => opt.value !== 2)
    }
  },
  methods: {
    selectChange(val) {
      this.$emit('selectChange')
    }
  }
}
</script>

<style lang="scss" scoped>
.batchVague {
  width: 100px;
}
</style>
